import { IPromoInfo } from '../../../types/newbuildingPromos';
import { pluralize } from '../../../utils/pluralize';

export const getMaxLoanTerm = (promo: IPromoInfo): string => {
  const maxLoanTerm = promo.mortgageParams?.maxLoanTerm;

  return maxLoanTerm ? pluralize(maxLoanTerm, ['год', 'года', 'лет']) : '—';
};
